(function($) {

    $.fn.drags = function(opt) {

        var $focalX = $(this).closest('.fileinput').find('.focal-point-x');
        var $focalY = $(this).closest('.fileinput').find('.focal-point-y');

        var boxW = parseInt($(this).parents().width()/2);
        var boxH = parseInt($(this).parents().height()/2);

        $(this).css('left', (($focalX.val()-(-1))*boxW)+10 );
        $(this).css('top', (($focalY.val()-(-1))*boxH)+10);

        var opt = $.extend({handle:"",cursor:"move"}, opt);

        if(opt.handle === "") {
            var $el = this;
        } else {
            var $el = this.find(opt.handle);
        }

        return $el.css('cursor', opt.cursor).on("mousedown", function(e) {
            if(opt.handle === "") {
                var $drag = $(this).addClass('draggable');
            } else {
                var $drag = $(this).addClass('active-handle').parent().addClass('draggable');
            }
            var z_idx = $drag.css('z-index'),
                drg_h = $drag.outerHeight(),
                drg_w = $drag.outerWidth(),
                pos_y = $drag.offset().top + drg_h - e.pageY,
                pos_x = $drag.offset().left + drg_w - e.pageX;
            $drag.css('z-index', 1000).parents().on("mousemove", function(e) {
                var T = e.pageY + pos_y - drg_h;
                var L = e.pageX + pos_x - drg_w;

                if(L < 0){
                    L = 0;
                }

                if(T < 0){
                    T = 0;
                }

                $('.draggable').offset({
                    top:T,
                    left:L
                }).on("mouseup", function() {
                    $(this).removeClass('draggable').css('z-index', z_idx);

                    $focalX.val((parseInt($(this).css('left'))-10)/boxW - 1);
                    $focalY.val((parseInt($(this).css('top'))-10)/boxH - 1);
                });
            });
            e.preventDefault(); // disable selection
        }).on("mouseup", function() {
            if(opt.handle === "") {
                $(this).removeClass('draggable');
            } else {
                $(this).removeClass('active-handle').parent().removeClass('draggable');
            }
        });

    }


    $('.fileinput.has-focal-point .fileinput-preview').each(function() {

        if($(this).attr('data-focal-point')) {

            $(this).append('<span class="center">x</span>').css('position', 'relative');
            var $center = $(this).find('.center');

            // prevent from choosing file on click
            $(this).on('click', '.center', function(e) {
                e.stopPropagation();
            });

            // make dragable
            $center.drags();
        }

    });

    $('form').on('change', function () {


        setTimeout(function(){
            $('.fileinput.has-focal-point .fileinput-preview').each(function() {

                    $(this).append('<span class="center">x</span>').css('position', 'relative');
                    var $center = $(this).find('.center');

                    // prevent from choosing file on click
                    $(this).on('click', '.center', function(e) {
                        e.stopPropagation();
                    });

                    // make dragable
                    $center.drags();
            });
        }, 1000);

    });


})(jQuery);